export const environment = {
  production: false,
  apiUrl: "https://credit-app-test.marcusfoodco.com/api",
  spaUrl: "https://credit-app-test.marcusfoodco.com",
  //buildVersion: '8.3.22-12', // Date - hour of build
  buildVersion: require("../../package.json").version + "-dev",
  envName: "Dev",
};
